module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "TOC-FBMHD"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Rail Fence")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Honey Bee")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trip Around the World")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Log Cabin")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Leaf")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Triangles")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spider’s Web")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tumbling Blocks")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dresden Plate")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('span', {
    attrs: {
      "href": "#/bm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All full size templates can be found at")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk/patterns",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk/patterns")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0